import { customElement } from 'lit/decorators.js';
import { TuftsGrid } from '../tufts-grid/tufts-grid';
import { CSSResultGroup } from 'lit';
import componentStyles from './tufts-grid-logo.css.lit';
import componentStylesEqual from '../tufts-grid/tufts-grid-equal.css.lit';
import gridComponentStyle from '../tufts-grid/tufts-grid.css.lit';

/**
 * The tufts grid component
 * @element tufts-grid-logo
 *
 * @slot - The default, and only slot for this element.
 *
 */

@customElement('tufts-grid-logo')
export class TuftsGridLogo extends TuftsGrid {
  static styles: CSSResultGroup = [
    gridComponentStyle,
    componentStylesEqual,
    componentStyles,
  ];
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-grid-logo': TuftsGridLogo;
  }
}
